import React from 'react'

const AnalyticsDataRightSkeleton = () => {
    return (
        <div className="flex flex-col w-full gap-6 animate-pulse max-w-[680px]">
            {/* Search All Analytics */}
            <div className="bg-white rounded-[10px] px-[35px] py-[25px] flex flex-col mb-2 h-[186px]">
                {/* Header row */}
                <div className="flex flex-row items-center justify-between gap-[10px] mb-4">
                    <div className="h-6 bg-lightBG rounded w-[180px] opacity-50"></div>
                    <div className="h-6 w-6 bg-lightBG rounded-full opacity-50"></div>
                </div>
                {/* Option buttons */}
                <div className="flex flex-row items-center gap-[10px] mb-6">
                    <div className="h-[30px] rounded-full min-w-[130px] bg-lightBG opacity-50"></div>
                    <div className="h-[30px] rounded-full min-w-[130px] bg-lightBG opacity-50"></div>
                    <div className="h-[30px] rounded-full min-w-[130px] bg-lightBG opacity-50"></div>
                </div>
                {/* Search input */}
                <div className="flex flex-row items-center gap-[6px]  rounded-full h-[44px] px-[20px] bg-lightBG relative">
                    <div className="flex-1 h-6 bg-white rounded opacity-30"></div>
                    <div className="h-6 w-6 bg-white rounded-full opacity-30"></div>
                </div>
            </div>

            {/* Create & Manage Reports */}
            <div className="bg-white rounded-[10px] px-[35px] py-[25px] flex flex-col mb-2">
                {/* Header row */}
                <div className="flex flex-row items-center justify-between gap-[10px]">
                    <div className="h-[30px] bg-lightBG rounded w-[251px] opacity-50"></div>
                    <div className="h-[50px] w-[192px] bg-lightBG rounded-full opacity-50"></div>
                </div>
                {/* Empty state/report list placeholder */}
                <div className="my-[19px] relative flex flex-col gap-[10px]">
                    <div className="h-[21px] bg-lightBG rounded-[10px] max-w-[20%] opacity-40"></div>
                    <div className="bg-lightBG h-[50px] rounded-[10px] w-full opacity-40"></div>
                </div>
                {/* View More button skeleton */}
                <div className="h-[40px] w-[110px] bg-lightBG rounded-full opacity-40 flex"></div>
            </div>

            <div className="flex flex-row justify-between items-center gap-2">
                {/* Time frame label */}
                <div className="h-6 w-[120px] bg-white rounded opacity-50"></div>
                {/* Period buttons */}
                <div className="flex flex-1 justify-between">
                    {[...Array(4)].map((_, idx) => (
                        <div key={idx} className="h-[30px] w-[111px] bg-white rounded-full opacity-50"></div>
                    ))}
                </div>
            </div>

            {/* How are you today? */}
            <div className="flex flex-col p-[35px] rounded-[10px] bg-white mb-2">
                {/* Header row */}
                <div className="flex flex-row items-center justify-between">
                    <div className="flex flex-col justify-center">
                        <div className="flex flex-row items-center mb-1">
                            <div className="h-6 w-[180px] bg-lightBG rounded opacity-50"></div>
                        </div>
                        <div className="h-4 w-[220px] bg-lightBG rounded mt-[5px] opacity-30"></div>
                    </div>
                    <div className="flex-1"></div>
                    <div className="h-[50px] w-[140px] bg-deepPurple rounded-full opacity-40"></div>
                </div>
                {/* ClassroomEngagementTrend skeleton */}
                <div className="flex flex-row justify-start items-center gap-4 mt-[30px] px-[20px]">
                    <div className="flex flex-row items-center w-[45%] gap-3 mt-[10px] ">
                        <div className="h-[45px] w-[45px] bg-[#7b7ac3] rounded-full opacity-40"></div>
                        <div className="h-4 w-[120px] bg-lightBG rounded opacity-30"></div>
                    </div>
                    <div className="flex flex-row items-center gap-3 mt-[10px] px-[20px]">
                        <div className="h-[45px] w-[45px] bg-[#7b7ac3] rounded-full opacity-40"></div>
                        <div className="h-4 w-[120px] bg-lightBG rounded opacity-30"></div>
                    </div>
                </div>
            </div>

            {/* General Engagement */}
            <div className="flex flex-col p-[35px] rounded-[10px] bg-white mb-2">
                {/* Header row */}
                <div className="flex flex-row items-center justify-between">
                    <div className="flex flex-col justify-center">
                        <div className="flex flex-row items-center mb-1">
                            <div className="h-6 w-[180px] bg-lightBG rounded opacity-50"></div>
                        </div>
                    </div>
                </div>
                {/* GeneralEngagement skeleton */}
                <div className="flex flex-row justify-start items-center gap-4 mt-[15px]">
                    <div className="flex flex-row items-center w-[45%] gap-3 mt-[10px] ">
                        <div className="h-[45px] w-[45px] bg-[#7b7ac3] rounded-full opacity-40"></div>
                        <div className="h-4 w-[120px] bg-lightBG rounded opacity-30"></div>
                    </div>
                    <div className="flex flex-row items-center gap-3 mt-[10px] px-[20px]">
                        <div className="h-[45px] w-[45px] bg-[#7b7ac3] rounded-full opacity-40"></div>
                        <div className="h-4 w-[120px] bg-lightBG rounded opacity-30"></div>
                    </div>
                </div>
            </div>

            {/* Registration */}
            <div className="flex flex-col p-[35px] rounded-[10px] bg-white mb-2">
                {/* Header row */}
                <div className="flex flex-row items-center justify-between">
                    <div className="flex flex-col justify-center">
                        <div className="flex flex-row items-center mb-1">
                            <div className="h-6 w-[180px] bg-lightBG rounded opacity-50"></div>
                        </div>
                    </div>
                </div>
                {/* Registration skeleton */}
                <div className="flex flex-row justify-start items-center gap-4 mt-[15px]">
                    <div className="flex flex-row items-center w-[45%] gap-3 mt-[10px] ">
                        <div className="h-[45px] w-[45px] bg-[#7b7ac3] rounded-full opacity-40"></div>
                        <div className="h-4 w-[120px] bg-lightBG rounded opacity-30"></div>
                    </div>
                    <div className="flex flex-row items-center gap-3 mt-[10px] px-[20px]">
                        <div className="h-[45px] w-[45px] bg-[#7b7ac3] rounded-full opacity-40"></div>
                        <div className="h-4 w-[120px] bg-lightBG rounded opacity-30"></div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default AnalyticsDataRightSkeleton
